import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from 'app/javascript/components/ui/button';
import type { PagyMetadata } from 'app/javascript/types';

interface AdminPaginationProps {
  pagy: PagyMetadata | undefined;
  onPageChange: (page: number) => void;
}

// Renders nothing while there is a single page — a lone "1 de 1" is noise.
export default function AdminPagination({ pagy, onPageChange }: AdminPaginationProps) {
  if (!pagy || pagy.pages <= 1) return null;

  return (
    <div className="flex items-center justify-between gap-3 pt-2">
      <p className="text-xs text-muted-foreground">
        Página {pagy.page} de {pagy.pages}
      </p>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="icon"
          onClick={() => onPageChange(pagy.prev!)}
          disabled={!pagy.prev}
          aria-label="Página anterior"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          onClick={() => onPageChange(pagy.next!)}
          disabled={!pagy.next}
          aria-label="Próxima página"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
